import Vue from 'vue';
import pageOverlay from '../PageOverlay/PageOverlay';
import searchInputAutocomplete from '../Floating/SearchInputAutocomplete';
import content from '../Content/Content';
import VisibilityService from '../../services/VisibilityService';

const modal = Vue.component('fl-modal', {
    template: `
    <div class="fl-pure-g fl-assisted-suggest" id="fl-modal-container" :style="style">
    <fl-search-input-autocomplete />
    <fl-page-overlay />
    <fl-content />
    </div>
  `,
    components: {
        PageOverlay: pageOverlay,
        SearchInputAutocomplete: searchInputAutocomplete,
        Content: content,
    },
    inject: ['config', 'HandleShopInteractionService'],
    data(): Record<string, any> {
        return {
            style: {},
        };
    },
    mounted(): void {
        this.HandleShopInteractionService.onInputTriggered(() => {
            const isFixed = this.HandleShopInteractionService.isActiveInputElementInFixedContext();

            this.$data.style = {
                position: isFixed ? 'fixed' : 'absolute',
                height: isFixed ? '100%' : `${document.body.offsetHeight}px`,
            };
        });

        this.HandleShopInteractionService.onScroll(() => {
            if (this.config.assistedSuggest.config.hideOnScroll) {
                VisibilityService.hide();
            }
        });

        this.HandleShopInteractionService.onResize(() => {
            if (this.config.assistedSuggest.config.hideOnResize) {
                VisibilityService.hide();
            }
        });
    },
});

export default modal;
